/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTextWrap = createReactComponent("text-wrap", "IconTextWrap", [
  ["path", { d: "M4 6l16 0", key: "svg-0" }],
  ["path", { d: "M4 18l5 0", key: "svg-1" }],
  ["path", { d: "M4 12h13a3 3 0 0 1 0 6h-4l2 -2m0 4l-2 -2", key: "svg-2" }]
]);

export { IconTextWrap as default };
//# sourceMappingURL=IconTextWrap.js.map
